import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vShow as _vShow, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "violet"
}
const _hoisted_2 = { class: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "flex items-center justify-between mb-8" }
const _hoisted_4 = { class: "text-2xl font-bold text-gray-900" }
const _hoisted_5 = { class: "mb-6 bg-white rounded-xl shadow-sm border border-gray-200 p-4" }
const _hoisted_6 = { class: "flex flex-wrap items-center gap-4" }
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = { class: "text-xs text-gray-500" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = { class: "text-xs text-gray-500" }
const _hoisted_11 = { value: "" }
const _hoisted_12 = { value: "road" }
const _hoisted_13 = { value: "trail" }
const _hoisted_14 = { value: "cross" }
const _hoisted_15 = { value: "stadium" }
const _hoisted_16 = { class: "flex items-center gap-2" }
const _hoisted_17 = { class: "text-xs text-gray-500" }
const _hoisted_18 = { class: "flex items-center gap-2" }
const _hoisted_19 = { class: "text-xs text-gray-500" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = { class: "text-xs text-gray-400 ml-auto" }
const _hoisted_22 = { class: "mb-8 bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden map-container" }
const _hoisted_23 = {
  ref: "mapContainer",
  style: {"height":"320px","width":"100%"}
}
const _hoisted_24 = {
  key: 1,
  class: "text-center py-12 text-gray-500"
}
const _hoisted_25 = { class: "grid gap-4" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" }
const _hoisted_28 = { class: "flex flex-col items-center sm:items-start sm:flex-row gap-4 flex-1" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "flex-1 min-w-0 text-center sm:text-left" }
const _hoisted_31 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_32 = { class: "text-sm font-medium text-blue-800" }
const _hoisted_33 = { class: "text-sm text-blue-600" }
const _hoisted_34 = {
  key: 0,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800"
}
const _hoisted_35 = { class: "text-lg font-semibold text-gray-900 block mb-1" }
const _hoisted_36 = { class: "flex flex-wrap items-center justify-center sm:justify-start gap-1.5" }
const _hoisted_37 = {
  key: 0,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
}
const _hoisted_38 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_39 = ["href"]
const _hoisted_40 = ["href"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6 max-h-[90vh] overflow-y-auto" }
const _hoisted_45 = { class: "text-lg font-bold text-gray-900 mb-6" }
const _hoisted_46 = {
  key: 0,
  class: "mb-4 bg-red-50 border border-red-200 rounded-lg px-4 py-3"
}
const _hoisted_47 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_48 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_49 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_50 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_51 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_52 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_53 = { value: "road" }
const _hoisted_54 = { value: "trail" }
const _hoisted_55 = { value: "cross" }
const _hoisted_56 = { value: "stadium" }
const _hoisted_57 = { class: "flex items-center justify-between mb-2" }
const _hoisted_58 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_59 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_60 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_63 = {
  ref: "formMapContainer",
  style: {"height":"200px","width":"100%"},
  class: "rounded-lg border border-gray-300"
}
const _hoisted_64 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_65 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_66 = { class: "block text-sm font-medium text-gray-700 mb-1" }
const _hoisted_67 = { class: "flex justify-end gap-3 pt-4" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { class: "bg-white rounded-xl shadow-xl w-full max-w-sm mx-4 p-6" }
const _hoisted_70 = { class: "text-lg font-bold text-gray-900 mb-2" }
const _hoisted_71 = { class: "text-sm text-gray-600 mb-6" }
const _hoisted_72 = { class: "flex justify-end gap-3" }
const _hoisted_73 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "competitions"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createCommentVNode(" Content "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.t('competitions.title')), 1 /* TEXT */),
        ($props.signedIn)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: $setup.openCreateModal,
              class: "bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-800 transition"
            }, _toDisplayString($setup.t('competitions.create')), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      _createCommentVNode(" Filters "),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString($setup.t('competitions.filter_date')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.filterDateFrom) = $event)),
              type: "date",
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.filterDateFrom]
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-xs text-gray-400" }, "—", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.filterDateTo) = $event)),
              type: "date",
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.filterDateTo]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, _toDisplayString($setup.t('competitions.running_type')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.filterType) = $event)),
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, [
              _createElementVNode("option", _hoisted_11, _toDisplayString($setup.t('competitions.filter_all')), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_12, _toDisplayString($setup.t('competitions.type_road')), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_13, _toDisplayString($setup.t('competitions.type_trail')), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_14, _toDisplayString($setup.t('competitions.type_cross')), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_15, _toDisplayString($setup.t('competitions.type_stadium')), 1 /* TEXT */)
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, $setup.filterType]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, _toDisplayString($setup.t('competitions.distances')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.filterDistFrom) = $event)),
              type: "number",
              min: "0",
              step: "1",
              placeholder: "min",
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 w-16 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.filterDistFrom]
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-xs text-gray-400" }, "—", -1 /* CACHED */)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.filterDistTo) = $event)),
              type: "number",
              min: "0",
              step: "1",
              placeholder: "max",
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 w-16 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, $setup.filterDistTo]
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-xs text-gray-400" }, "km", -1 /* CACHED */))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, _toDisplayString($setup.t('competitions.filter_search')) + ":", 1 /* TEXT */),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.filterSearch) = $event)),
              type: "text",
              placeholder: $setup.t('competitions.filter_search_placeholder'),
              class: "text-xs border border-gray-300 rounded-lg px-2 py-1.5 w-48 focus:outline-none focus:ring-2 focus:ring-blue-500"
            }, null, 8 /* PROPS */, _hoisted_20), [
              [_vModelText, $setup.filterSearch]
            ])
          ]),
          _createElementVNode("span", _hoisted_21, _toDisplayString($setup.filteredCompetitions.length) + " / " + _toDisplayString($props.competitions.length), 1 /* TEXT */)
        ])
      ]),
      _createCommentVNode(" Map "),
      _withDirectives(_createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, null, 512 /* NEED_PATCH */)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.competitionsWithCoords.length > 0]
      ]),
      _createCommentVNode(" Flash "),
      ($setup.flash)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['mb-4 px-4 py-3 rounded-lg text-sm', $setup.flash.type === 'success' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'])
          }, _toDisplayString($setup.flash.message), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" List "),
      ($setup.filteredCompetitions.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($setup.t('competitions.no_competitions')), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredCompetitions, (comp) => {
          return (_openBlock(), _createElementBlock("div", {
            key: comp.id,
            onClick: $event => ($setup.goToComp($event, comp)),
            class: _normalizeClass(['rounded-xl shadow-sm border p-6 transition cursor-pointer', $setup.isPast(comp) ? 'bg-gray-50 border-gray-200 opacity-60' : 'bg-white border-gray-200 hover:shadow-md'])
          }, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                (comp.logo_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: comp.logo_url,
                      class: "h-24 rounded-lg object-contain border border-gray-200 shrink-0 self-center sm:self-start"
                    }, null, 8 /* PROPS */, _hoisted_29))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString($setup.formatDate(comp.date)), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_33, _toDisplayString($setup.formatTime(comp.date)), 1 /* TEXT */),
                    (comp.pending)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString($setup.t('competitions.pending')), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("span", _hoisted_35, _toDisplayString(comp.name), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_36, [
                    (comp.running_type)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString($setup.t('competitions.type_' + comp.running_type)), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((comp.distances || []), (d) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: d.id,
                        class: "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700"
                      }, [
                        _createTextVNode(_toDisplayString(d.km) + " km ", 1 /* TEXT */),
                        (d.elevation_gain)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_38, "↑" + _toDisplayString(d.elevation_gain) + "m", 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  (comp.link || comp.results_link)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "mt-1 flex flex-wrap gap-2",
                        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        (comp.link)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: comp.link,
                              target: "_blank",
                              class: "inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition"
                            }, [
                              _createTextVNode(_toDisplayString($setup.t('competitions.visit_link')) + " ", 1 /* TEXT */),
                              _cache[20] || (_cache[20] = _createElementVNode("svg", {
                                class: "w-3.5 h-3.5",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                })
                              ], -1 /* CACHED */))
                            ], 8 /* PROPS */, _hoisted_39))
                          : _createCommentVNode("v-if", true),
                        (comp.results_link)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: comp.results_link,
                              target: "_blank",
                              class: "inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-green-700 rounded-lg hover:bg-green-800 transition"
                            }, [
                              _createTextVNode(_toDisplayString($setup.t('competitions.results')) + " ", 1 /* TEXT */),
                              _cache[21] || (_cache[21] = _createElementVNode("svg", {
                                class: "w-3.5 h-3.5",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M9 17v-6m4 6V7m4 10v-3M5 21h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z"
                                })
                              ], -1 /* CACHED */))
                            ], 8 /* PROPS */, _hoisted_40))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              ($setup.canEdit(comp))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "flex flex-col gap-2 ml-4",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                  }, [
                    ($props.userAdmin && comp.pending)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: $event => ($setup.approveCompetition(comp)),
                          class: "px-3 py-1.5 text-xs font-medium text-green-700 bg-green-50 rounded-lg hover:bg-green-100 transition"
                        }, _toDisplayString($setup.t('competitions.approve')), 9 /* TEXT, PROPS */, _hoisted_41))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      onClick: $event => ($setup.openEditModal(comp)),
                      class: "px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 rounded-lg hover:bg-blue-100 transition"
                    }, _toDisplayString($setup.t('competitions.edit')), 9 /* TEXT, PROPS */, _hoisted_42),
                    _createElementVNode("button", {
                      onClick: $event => ($setup.confirmDelete(comp)),
                      class: "px-3 py-1.5 text-xs font-medium text-red-700 bg-red-50 rounded-lg hover:bg-red-100 transition"
                    }, _toDisplayString($setup.t('competitions.delete')), 9 /* TEXT, PROPS */, _hoisted_43)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_26))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createCommentVNode(" Create/Edit Modal "),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("h2", _hoisted_45, _toDisplayString($setup.editing ? $setup.t('competitions.edit_competition') : $setup.t('competitions.new_competition')), 1 /* TEXT */),
            ($setup.formErrors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.formErrors, (error) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: error,
                      class: "text-sm text-red-700"
                    }, _toDisplayString(error), 1 /* TEXT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("form", {
              onSubmit: _withModifiers($setup.submitForm, ["prevent"]),
              class: "space-y-4"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_47, _toDisplayString($setup.t('competitions.name')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.form.name) = $event)),
                  type: "text",
                  required: "",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.name]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_48, _toDisplayString($setup.t('competitions.date')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.form.date) = $event)),
                  type: "datetime-local",
                  required: "",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.date]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_49, _toDisplayString($setup.t('competitions.link')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.form.link) = $event)),
                  type: "url",
                  placeholder: "https://...",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.link]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_50, _toDisplayString($setup.t('competitions.results_link')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($setup.form.results_link) = $event)),
                  type: "url",
                  placeholder: "https://...",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.results_link]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_51, _toDisplayString($setup.t('competitions.description')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.form.description) = $event)),
                  rows: "3",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, $setup.form.description]
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_52, _toDisplayString($setup.t('competitions.running_type')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (($setup.form.running_type) = $event)),
                  class: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                }, [
                  _cache[22] || (_cache[22] = _createElementVNode("option", { value: "" }, "—", -1 /* CACHED */)),
                  _createElementVNode("option", _hoisted_53, _toDisplayString($setup.t('competitions.type_road')), 1 /* TEXT */),
                  _createElementVNode("option", _hoisted_54, _toDisplayString($setup.t('competitions.type_trail')), 1 /* TEXT */),
                  _createElementVNode("option", _hoisted_55, _toDisplayString($setup.t('competitions.type_cross')), 1 /* TEXT */),
                  _createElementVNode("option", _hoisted_56, _toDisplayString($setup.t('competitions.type_stadium')), 1 /* TEXT */)
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, $setup.form.running_type]
                ])
              ]),
              _createCommentVNode(" Distances "),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("label", _hoisted_58, _toDisplayString($setup.t('competitions.distances')), 1 /* TEXT */),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: $setup.addDistance,
                    class: "text-xs text-blue-700 hover:text-blue-900 font-medium"
                  }, "+ " + _toDisplayString($setup.t('competitions.add_distance')), 1 /* TEXT */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form.distances, (d, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "flex items-center gap-2 mb-2"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": $event => ((d.km) = $event),
                      type: "number",
                      step: "0.1",
                      min: "0",
                      placeholder: $setup.t('competitions.km'),
                      class: "w-24 px-2 py-1.5 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                    }, null, 8 /* PROPS */, _hoisted_59), [
                      [_vModelText, d.km]
                    ]),
                    _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-xs text-gray-400" }, "km", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": $event => ((d.elevation_gain) = $event),
                      type: "number",
                      min: "0",
                      placeholder: $setup.t('competitions.elevation'),
                      class: "w-24 px-2 py-1.5 border border-gray-300 rounded text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                    }, null, 8 /* PROPS */, _hoisted_60), [
                      [_vModelText, d.elevation_gain]
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-xs text-gray-400" }, "↑m", -1 /* CACHED */)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: $event => ($setup.form.distances.splice(idx, 1)),
                      class: "text-red-400 hover:text-red-600 text-sm"
                    }, "×", 8 /* PROPS */, _hoisted_61)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createVNode($setup["ImageUpload"], {
                modelValue: $setup.form.logo_url,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (($setup.form.logo_url) = $event)),
                label: $setup.t('competitions.logo'),
                "upload-text": $setup.t('competitions.upload_logo'),
                "change-text": $setup.t('competitions.change_logo'),
                "remove-text": $setup.t('competitions.remove_logo'),
                "csrf-token": $props.csrfToken,
                "upload-type": "competitions"
              }, null, 8 /* PROPS */, ["modelValue", "label", "upload-text", "change-text", "remove-text", "csrf-token"]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_62, _toDisplayString($setup.t('competitions.pick_location')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_63, null, 512 /* NEED_PATCH */)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_65, _toDisplayString($setup.t('competitions.latitude')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (($setup.form.latitude) = $event)),
                    type: "number",
                    step: "0.0000001",
                    readonly: "",
                    class: "w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-sm"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.form.latitude]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_66, _toDisplayString($setup.t('competitions.longitude')), 1 /* TEXT */),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (($setup.form.longitude) = $event)),
                    type: "number",
                    step: "0.0000001",
                    readonly: "",
                    class: "w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-sm"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.form.longitude]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: $setup.closeModal,
                  class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
                }, _toDisplayString($setup.t('competitions.cancel')), 1 /* TEXT */),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: $setup.submitting,
                  class: "px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50"
                }, _toDisplayString($setup.submitting ? '...' : ($setup.editing ? $setup.t('competitions.save') : $setup.t('competitions.create'))), 9 /* TEXT, PROPS */, _hoisted_68)
              ])
            ], 32 /* NEED_HYDRATION */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Delete Modal "),
    ($setup.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
          onClick: _withModifiers($setup.closeDeleteModal, ["self"])
        }, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("h2", _hoisted_70, _toDisplayString($setup.t('competitions.confirm_delete')), 1 /* TEXT */),
            _createElementVNode("p", _hoisted_71, _toDisplayString($setup.t('competitions.confirm_delete_message')), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("button", {
                onClick: $setup.closeDeleteModal,
                class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
              }, _toDisplayString($setup.t('competitions.cancel')), 1 /* TEXT */),
              _createElementVNode("button", {
                onClick: $setup.deleteCompetition,
                disabled: $setup.submitting,
                class: "px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition disabled:opacity-50"
              }, _toDisplayString($setup.submitting ? '...' : $setup.t('competitions.delete')), 9 /* TEXT, PROPS */, _hoisted_73)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}